import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {isTeammateNamespace} from '../../helpers/models/namespaceHelpers';
import {SettingsSidebarInfoBox} from '../common/settingsSidebarInfoBox';

/*
 * Props.
 */

interface SettingsTagsListSidebarProps {
  namespace: string;
  onCloseClick: Handler;
  onFooterClick: Handler;
  isInArchivedView: boolean;
}

/*
 * Component.
 */

export const SettingsTagsListSidebar: FC<SettingsTagsListSidebarProps> = (props) => {
  if (props.isInArchivedView) {
    return (
      <SettingsSidebarInfoBox
        title={<Trans id="settingstags-infobox-archived-title">Archived tags</Trans>}
        body={
          <Trans id="settingstags-infobox-archived-body">
            <ul>
              <li>Stay on existing conversations</li>
              <li>Are searchable in inboxes</li>
              <li>Are searchable in Analytics</li>
              <li>Cannot be added to new conversations</li>
            </ul>
          </Trans>
        }
        footer={<Trans id="settingstags-infobox-private-footer">Learn more</Trans>}
        onCloseClick={props.onCloseClick}
        onFooterClick={props.onFooterClick}
      />
    );
  }

  if (isTeammateNamespace(props.namespace)) {
    return (
      <SettingsSidebarInfoBox
        title={<Trans id="settingstags-infobox-private-title">Individual tags</Trans>}
        body={
          <p>
            <Trans id="settingstags-infobox-private-body">
              Tags are labels to help you keep track of conversations related to a given topic. Private tags
              are only visible to you, even when you add a private tag on shared conversations. You can click
              the +tag button at the top of the message to apply a tag.
            </Trans>
          </p>
        }
        footer={<Trans id="settingstags-infobox-private-footer">Learn more</Trans>}
        onCloseClick={props.onCloseClick}
        onFooterClick={props.onFooterClick}
      />
    );
  }

  return (
    <SettingsSidebarInfoBox
      title={<Trans id="settingstags-infobox-team-title">Team tags</Trans>}
      body={
        <p>
          <Trans id="settingstags-infobox-team-body">
            Tags are labels to help you keep track of conversations related to a given topic. Team Tags are
            visible to everyone on your Team. In analytics, admins can create reports based on tags. You can
            click the +tag button at the top of the message to apply a tag.
          </Trans>
        </p>
      }
      footer={<Trans id="settingstags-infobox-team-footer">Learn more</Trans>}
      onCloseClick={props.onCloseClick}
      onFooterClick={props.onFooterClick}
    />
  );
};
